/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import apiClient from '../api/client';

export const mediaLibraryService = {
  // GET /api/media-library
  getMediaItems: (params = {}) => apiClient.get('/media-library', { params }),
};
